// extracted by mini-css-extract-plugin
module.exports = {"selectCard":"selectCard_selectCard__jAbIl","label":"selectCard_label__GJ6ct","selected":"selectCard_selected__7urXS"};